// ZOD
import * as z from 'zod';
import { HeaderZod, HeaderType } from '@/components/organisms/Header/HeaderType';

// Strapi
import { header } from '@/services/strapiPopulate';

// Utils
import { formatZodError } from '@/utils/error';

// Client
import client from '../client';

export const getHeader = async (): Promise<HeaderType> => {
  const response = await client.get('/api/header', {
    params: {
      populate: header,
    },
  });

  try {
    return await HeaderZod.parseAsync(response.data?.data);
  } catch (error) {
    if (error instanceof z.ZodError) {
      throw new Error(`API response do not match Header structure:\n${formatZodError(error, response.data?.data)}`);
    }
    throw error;
  }
};
